import * as Yup from 'yup';

export const step1ValidationSchema = Yup.object({

    name: Yup.string()
        .required('Name is required')
        .min(2, 'Name must be at least 2 characters')
        .max(50, 'Name must be at most 50 characters')
        .matches(/^[a-zA-Z\s]*$/, 'Name should only contain letters'),
    email: Yup.string()
        .nullable()
        .transform(value => value || null)
        .email('Invalid email format'),

    phone: Yup.string()
        .required('Phone number is required')
        .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits'),
    gender: Yup.number()
        .required('Gender is required')
        .oneOf([1, 2, 3], 'Invalid gender selection'),
    // dob: Yup.date()
    //     .required('Date of birth is required'),
    dob: Yup.string()
        .required('Date of birth is required')
        .matches(
            /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/,
            'Date must be in DD-MM-YYYY format'
        )
        .test('is-valid-date', 'Please enter a valid date', (value) => {
            if (!value) return false;
            const [day, month, year] = value.split('-').map(Number);
            const date = new Date(year, month - 1, day);
            return (
                date.getFullYear() === year &&
                date.getMonth() === month - 1 &&
                date.getDate() === day
            );
        })
        .test('is-not-future', 'Date of birth cannot be in the future', (value) => {
            if (!value) return false;
            const [day, month, year] = value.split('-').map(Number);
            const dob = new Date(year, month - 1, day);
            const today = new Date();
            return dob <= today;
        }),
    aadharNumber: Yup.string()
        .required('Aadhar number is required')
        .matches(/^[0-9]{12}$/, 'Aadhar number must be exactly 12 digits'),
    // panNumber: Yup.string()
    //     .nullable()
    //     .transform(value => value || null)
    //     .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN number format'),
    address: Yup.string()
        .required('Address is required')
        .min(10, 'Address must be at least 10 characters')
        .max(200, 'Address must be at most 200 characters'),
    // city: Yup.string()
    //     .required('City is required')
    //     .min(2, 'City must be at least 2 characters')
    //     .matches(/^[a-zA-Z\s]*$/, 'City should only contain letters'),
    // pincode: Yup.string()
    //     .required('Pincode is required')
    //     .matches(/^[0-9]{6}$/, 'Pincode must be exactly 6 digits'),
});

export const step2ValidationSchema = Yup.object({
    studentId: Yup.string()
        .required('Student ID is required')
        .min(5, 'Student ID must be at least 5 characters')
        .max(20, 'Student ID must be at most 20 characters'),
    instituteName: Yup.string()
        .required('Institute name is required')
        .min(2, 'Institute name must be at least 2 characters')
        .max(100, 'Institute name must be at most 100 characters'),
    occupation: Yup.number()
        .required('Occupation is required')
        .oneOf([1, 2], 'Invalid occupation selection'),

    academicStanding: Yup.number()
        .nullable()
        .transform(value => value || null)
        .when('occupation', {
            is: (val) => val !== 2, // Required only if NOT Salaried
            then: (schema) => schema.required('Academic standing is required').oneOf([1, 2, 3, 4], 'Invalid academic standing'),
            otherwise: (schema) => schema.nullable()
        }),
    course: Yup.string()
        .nullable()
        .transform(value => value || null)
        .when('occupation', {
            is: (val) => val === 1, // Required only if Student
            then: (schema) => schema.required('Course is required').oneOf(['UG', 'PG', 'Diploma', 'PhD'], 'Invalid course selection'),
            otherwise: (schema) => schema.nullable()
        }),
    // academicStanding: Yup.number()
    //     .required('Academic standing is required')
    //     .oneOf([1, 2, 3, 4], 'Invalid academic standing'),
    // course: Yup.string()
    //     .required('Course is required')
    //     .oneOf(['UG', 'PG', 'Diploma', 'PhD'], 'Invalid course selection'),
    stream: Yup.string()
        .required('Stream is required')
        .min(2, 'Stream must be at least 2 characters'),
    intakeDate: Yup.string()
        .required('Intake date is required')
        .oneOf(['2025-2026', '2026-2027'], 'Invalid intake date'),
});

export const step3ValidationSchema = Yup.object({
    // Father's details - Required
    fatherName: Yup.string()
        .required("Father's name is required")
        .min(2, "Father's name must be at least 2 characters")
        .max(50, "Father's name must be at most 50 characters")
        .matches(/^[a-zA-Z\s]*$/, "Name should only contain letters"),

    fatherPhone: Yup.string()
        .required("Father's phone number is required")
        .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits'),

    fatherEmail: Yup.string()
        .nullable()
        .transform(value => value || null)
        .email('Invalid email format'),

    // Mother's details - Optional
    motherName: Yup.string()
        .nullable()
        .transform(value => value || null)
        .min(2, "Mother's name must be at least 2 characters")
        .max(50, "Mother's name must be at most 50 characters")
        .matches(/^[a-zA-Z\s]*$/, "Name should only contain letters"),

    motherPhone: Yup.string()
        .nullable()
        .transform(value => value || null)
        .when('motherName', {
            is: (val) => val && val.length > 0,
            then: (schema) => schema.required("Mother's phone number is required").matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits'),
            otherwise: (schema) => schema.nullable()
        }),

    motherEmail: Yup.string()
        .nullable()
        .transform(value => value || null)
        .email('Invalid email format'),


    // Guardian details - Optional with conditional validation
    guardianName: Yup.string()
        .nullable()
        .transform(value => value || null)
        .min(2, 'Guardian name must be at least 2 characters')
        .max(50, 'Guardian name must be at most 50 characters')
        .matches(/^[a-zA-Z\s]*$/, "Name should only contain letters"),

    guardianRelation: Yup.number()
        .nullable()
        .transform(value => value || null)
        .when('guardianName', {
            is: (val) => val && val.length > 0,
            then: (schema) => schema.required('Relation is required').oneOf([1, 2, 3, 4, 5], 'Invalid relation'),
            otherwise: (schema) => schema.nullable()
        }),

    guardianPhone: Yup.string()
        .nullable()
        .transform(value => value || null)
        .when('guardianName', {
            is: (val) => val && val.length > 0,
            then: (schema) => schema.required('Phone number is required').matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits'),
            otherwise: (schema) => schema.nullable()
        }),

    guardianEmail: Yup.string()
        .nullable()
        .transform(value => value || null)
        .when('guardianName', {
            is: (val) => val && val.length > 0,
            then: (schema) => schema.email('Invalid email format'),
            otherwise: (schema) => schema.nullable()
        }),
});

export const initialValues = {
    studentId: '',
    name: '',
    email: '',
    phone: '',
    gender: '',
    dob: '',
    aadharNumber: '',
    // panNumber: '',
    address: '',
    // city: '',
    // pincode: '',
    academicStanding: '',
    occupation: '',
    instituteName: '',
    course: '',
    stream: '',
    intakeDate: '',
    // guardianName: '',
    // guardianRelation: '',
    // guardianEmail: '',
    // guardianPhone: '',
    // Father's details
    fatherName: '',
    fatherPhone: '',
    fatherEmail: '',
    // Mother's details
    motherName: '',
    motherPhone: '',
    motherEmail: '',
    // Guardian details
    guardianName: '',
    guardianRelation: '',
    guardianPhone: '',
    guardianEmail: '',
};

export const getStepFields = (step) => {
    switch (step) {
        // case 1: return ['name', 'email', 'phone', 'gender', 'dob', 'aadharNumber', 'panNumber', 'address', 'city', 'pincode'];
        case 1: return ['name', 'email', 'phone', 'gender', 'dob', 'aadharNumber', 'address'];
        case 2: return ['studentId', 'instituteName', 'occupation', 'academicStanding', 'course', 'stream', 'intakeDate'];
        case 3: return ['fatherName', 'fatherPhone', 'fatherEmail', 'motherName', 'motherPhone', 'motherEmail', 'guardianName', 'guardianRelation', 'guardianPhone', 'guardianEmail'];
        // case 3: return ['guardianName', 'guardianRelation', 'guardianEmail', 'guardianPhone'];
        default: return [];
    }
};